export default "__VITE_ASSET__Bbr8PusE__"